import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { renderStars } from "../../common/utils";

const Vehicle_Card = ({ title, VehicleDetails }) => {

  return (
    <>
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center py-3">
          <h3 className="mb-3">{title}</h3>
          <div className="vehicle-card-wrapper">
            {VehicleDetails.map((detail) => (
              <div
                key={detail.id}
                className="cards cards-shadow border mb-3 border-1 bg-white p-2"
              >
                <NavLink
                  className="show text-decoration-none"
                  to={`${detail.slug}`}
                >
                  <img
                    alt="Suzuki Alto"
                    title="Suzuki Alto"
                    className="vehicle-img"
                    src={detail.media[0]?.original_url}
                  />

                  <h5 className="fs-sm fw-bold text-black bg-white text-center mt-3">
                    {detail.title}
                  </h5>
                </NavLink>
                <div className="cards-content text-center bg-white">
                  <p className=" text-success small-text-review mb-1">
                    {detail.price_start + " - " + detail.price_end}
                  </p>
                  <div className="d-flex flex-column flex-lg-row align-items-lg-center">
                  
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Vehicle_Card;
